import options from '../options/options.js';
// @vite-ignore
import * as jQuery from '../../lib/jquery/jquery-3.1.1.min.js';
import navLinksData from './nav-links-data.js';
const $ = jQuery;

const ATTRS = {
    /* The state attribute name */
    state: 'data-state',
    id: 'data-id',
    tocID: 'data-tocid',
};

const STATE = {
    /* The possible states */
    pending: 'pending',
    notReady: 'not-ready',
    collapsed: 'collapsed',
    expanded: 'expanded',
    leaf: 'leaf',
};

const BUTTON_ACTION_ID = {
    expand: 'button-expand-action',
    collapse: 'button-collapse-action',
    pending: 'button-pending-action',
};

const jsonBaseDir = 'nav-links/json';

/**
 * The path of the output directory, relative to the current HTML file.
 * @type {String}
 */
let path2root = null;

$(document).ready(function () {
    // Register the click handler for the TOC
    const topicRefExpandBtn = $('.wh_publication_toc .wh-expand-btn');
    topicRefExpandBtn.click(toggleTocExpand);

    /* Toggle expand/collapse on enter and space */
    topicRefExpandBtn.keypress(handleKeyEvent);

    // Register the hover handler for the Menu
    const menuTopicRefSpan = $('.wh_top_menu li');
    menuTopicRefSpan.hover(menuItemHovered);
});

/**
 * Retrieves the path of the output directory, relative to the current HTML file.
 *
 * @returns {*} the path of the output directory, relative to the current HTML file.
 */
function getPathToRoot() {
    if (path2root == null) {
        path2root = $('meta[name="wh-path2root"]').attr('content');
        if (path2root == null || path2root == undefined) {
            path2root = '';
        }
    }
    return path2root;
}

/*
 * Toggles expand/collapse on enter and space
 */
function handleKeyEvent(event) {
    // Enter & Spacebar events
    if (event.which === 13 || event.which === 32) {
        event.preventDefault();
        toggleTocExpand.call(this);
    }
}

function toggleTocExpand() {
    const topicRef = $(this).closest('.topicref');
    const state = topicRef.attr(ATTRS.state);
    const parentLi = $(this).closest('li');
    const titleLink = $(this).siblings('.title').children('a');
    const titleLinkID = titleLink.attr('id');

    if (state == null) {
        // Do nothing
    } else if (state == STATE.pending) {
        // Do nothing
    } else if (state == STATE.notReady) {
        topicRef.attr(ATTRS.state, STATE.pending);
        parentLi.attr('aria-expanded', 'true');
        $(this).attr('aria-labelledby', BUTTON_ACTION_ID.pending + ' ' + titleLinkID);
        retrieveChildNodes(topicRef, true);
    } else if (state == STATE.expanded) {
        topicRef.attr(ATTRS.state, STATE.collapsed);
        $(this).attr('aria-labelledby', BUTTON_ACTION_ID.expand + ' ' + titleLinkID);
        parentLi.attr('aria-expanded', 'false');
    } else if (state == STATE.collapsed) {
        topicRef.attr(ATTRS.state, STATE.expanded);
        $(this).attr('aria-labelledby', BUTTON_ACTION_ID.collapse + ' ' + titleLinkID);
        parentLi.attr('aria-expanded', 'true');
    }
}

/**
 * Loads the data containing the list of child nodes for the current topic node.
 * Builds the list of child topics element nodes based on the retrieved data.
 *
 * @param topicRefSpan The topicref 'span' element of the current node from TOC / Menu.
 * @param forToc <p><code>true</code> if the child nodes should be retrieved for the TOC.</p>
 *               <p><code>false</code> if the child nodes should be retireved for the Menu.</p>
 */
function retrieveChildNodes(topicRefSpan, forToc) {
    const tocId = $(topicRefSpan).attr(ATTRS.tocID);
    if (tocId != null) {
        // Static import for the JSON data
        const data = navLinksData[tocId];
        if (data != null) {
            const topics = data.topics;
            const topicLi = topicRefSpan.closest('li');
            const topicsUl = createTopicsList(topics, forToc);

            if (!forToc) {
                const loadingDotsUl = topicLi.children('ul.loading');
                // Remove the loading dots from the menu.
                loadingDotsUl.find('li').remove();
                loadingDotsUl.removeClass('loading');

                topicsUl.forEach(function (topic) {
                    loadingDotsUl.append(topic);
                });
            } else {
                const topicsUlParent = $('<ul role="group"/>');
                topicsUl.forEach(function (topic) {
                    topicsUlParent.append(topic);
                });
                topicLi.append(topicsUlParent);

                const titleLink = topicRefSpan.find('.title > a');
                const titleLinkID = titleLink.attr('id');

                const expandBtn = topicRefSpan.children('.wh-expand-btn');
                expandBtn.attr('aria-labelledby', BUTTON_ACTION_ID.collapse + ' ' + titleLinkID);
            }

            topicRefSpan.attr(ATTRS.state, STATE.expanded);
        } else {
            topicRefSpan.attr(ATTRS.state, STATE.leaf);
        }
    }
}

/**
 * Creates the <code>ul</code> element containing the child topic nodes of the current topic.
 *
 * @param topics The array of containing info about the child topics.
 * @param forToc <p><code>true</code> if the element belongs to the TOC.</p>
 *               <p><code>false</code> if the element belongs to the Menu.</p>
 *
 * @returns {*|jQuery|HTMLElement} the <code>li</code> elements representing the child topic nodes of the current topic.
 */
function createTopicsList(topics, forToc) {
    const topicsArray = [];
    topics.forEach(function (topic) {
        if (forToc || !topic.menu.isHidden) {
            const topicLi = createTopicLi(topic, forToc);
            topicsArray.push(topicLi);
        }
    });
    return topicsArray;
}

/**
 * Creates the <code>li</code> element containing a topic node.
 *
 * @param topic The info about the topic node.
 * @param forToc <p><code>true</code> if the element belongs to the TOC.</p>
 *               <p><code>false</code> if the element belongs to the Menu.</p>
 *
 * @returns {*|jQuery|HTMLElement} the <code>li</code> element containing a topic node.
 */
function createTopicLi(topic, forToc) {
    const li = $('<li>');
    if (forToc) {
        li.attr('role', 'treeitem');
        if (hasChildren(topic, forToc)) {
            li.attr('aria-expanded', 'false');
        }
    } else {
        if (topic.menu.hasChildren) {
            li.addClass('has-children');
        }
        const topicImage = topic.menu.image;
        if (topicImage != null && topicImage.href != null) {
            const menuImageSpan = createMenuImageSpan(topic);
            li.append(menuImageSpan);
        }
        li.hover(menuItemHovered);
    }

    // .topicref span
    const topicRefSpan = createTopicRefSpan(topic, forToc);
    // append the topicref node in parent
    li.append(topicRefSpan);

    return li;
}

/**
 * Creates the <span> element containing the image icon for the current node in the menu.
 * @param topic The JSON object containing the info about the associated node.
 *
 * @returns {*|jQuery|HTMLElement} the image 'span' element.
 */
function createMenuImageSpan(topic) {
    const topicImage = topic.menu.image;
    // Image span
    const imgSpan = $('<span>', { class: 'topicImg' });

    const isExternalReference = topicImage.scope == 'external';
    let imageHref = '';
    if (!isExternalReference) {
        imageHref += getPathToRoot();
    }
    imageHref += topicImage.href;

    const img = $('<img>', {
        src: imageHref,
        alt: topic.title,
    });

    if (topicImage.height != null) {
        img.attr('height', topicImage.height);
    }
    if (topicImage.width != null) {
        img.attr('width', topicImage.width);
    }
    imgSpan.append(img);

    return imgSpan;
}

/**
 * Creates the <span> element containing the title and the link to the topic associated to a node in the menu or the TOC.
 *
 * @param topic The JSON object containing the info about the associated node.
 *
 * @returns {*|jQuery|HTMLElement} the topic title 'span' element.
 */
function createTopicRefSpan(topic, forToc) {
    const isExternalReference = topic.scope == 'external';

    // .topicref span
    const topicRefSpan = $('<span>');
    topicRefSpan.addClass('topicref');
    if (topic.outputclass != null) {
        topicRefSpan.addClass(topic.outputclass);
    }

    // WH-1820 Copy the Ditaval "pass through" attributes.
    const dataAttributes = topic.attributes;
    if (typeof dataAttributes !== 'undefined') {
        const attrsNames = Object.keys(dataAttributes);
        attrsNames.forEach(function (attr) {
            topicRefSpan.attr(attr, dataAttributes[attr]);
        });
    }

    topicRefSpan.attr(ATTRS.tocID, topic.tocID);

    // Current node state
    const containsChildren = hasChildren(topic, forToc);
    if (containsChildren) {
        // This state means that the child topics should be retrieved later.
        topicRefSpan.attr(ATTRS.state, STATE.notReady);
    } else {
        topicRefSpan.attr(ATTRS.state, STATE.leaf);
    }

    if (forToc) {
        const expandBtn = $('<span>', {
            class: 'wh-expand-btn',
            role: 'button',
        });

        if (containsChildren) {
            expandBtn.attr('aria-labelledby', BUTTON_ACTION_ID.expand + ' ' + getTopicLinkID(topic));
            expandBtn.attr('tabindex', '0');
        }

        expandBtn.click(toggleTocExpand);
        expandBtn.keypress(handleKeyEvent);
        topicRefSpan.append(expandBtn);
    }

    // Topic ref link
    let linkHref = '';
    if (topic.href != null && topic.href != 'javascript:void(0)') {
        if (!isExternalReference) {
            linkHref += getPathToRoot();
        }
        linkHref += topic.href;
    }
    const link = $('<a>', {
        href: linkHref,
        html: topic.title,
    });

    if (forToc) {
        link.attr('id', getTopicLinkID(topic));
    }

    if (isExternalReference) {
        link.attr('target', '_blank');
    }
    const titleSpan = $('<span>', {
        class: 'title',
    });

    titleSpan.append(link);

    // Topic ref short description
    if (forToc && topic.shortdesc != null) {
        const tooltipSpan = $('<span>', {
            class: 'wh-tooltip',
            html: topic.shortdesc,
        });

        /* WH-1518: Check if the tooltip has content. */
        if (tooltipSpan.find('.shortdesc:empty').length == 0) {
            // Update the relative links
            const pathToRoot = getPathToRoot();
            const links = tooltipSpan.find('a[href]');
            links.each(function () {
                const href = $(this).attr('href');
                if (!(href.startsWith('http:') || href.startsWith('https:'))) {
                    $(this).attr('href', pathToRoot + href);
                }
            });
            titleSpan.append(tooltipSpan);
        }
    }

    topicRefSpan.append(titleSpan);

    return topicRefSpan;
}

function getTopicLinkID(topic) {
    return topic.tocID + '-link';
}

function hasChildren(topic, forToc) {
    // If the "topics" property is not specified then it means that children should be loaded from the
    // module referenced in the "next" property
    const children = topic.topics;
    let hasChildren;
    if (children != null && children.length == 0) {
        hasChildren = false;
    } else if (!forToc && topic.menu != null) {
        hasChildren = topic.menu.hasChildren;
    } else {
        hasChildren = true;
    }
    return hasChildren;
}

function menuItemHovered() {
    const topicRefSpan = $(this).children('.topicref');
    const state = topicRefSpan.attr(ATTRS.state);
    if (state == null) {
        // Do nothing
    } else if (state == STATE.pending) {
        // Do nothing
    } else if (state == STATE.notReady) {
        topicRefSpan.attr(ATTRS.state, STATE.pending);

        const dot = $('<span>', {
            class: 'dot',
        });
        const loadingMarker = $('<ul>', {
            class: 'loading',
            html: $('<li>', {
                html: [dot, dot.clone(), dot.clone()],
            }),
        });

        $(this).append(loadingMarker);

        handleMenuPosition($(this));
        retrieveChildNodes(topicRefSpan, false);
    } else if (state == STATE.expanded) {
        handleMenuPosition($(this));
    }
}

const dirAttr = $('html').attr('dir');
let rtlEnabled = false;
if (dirAttr == 'rtl') {
    rtlEnabled = true;
}

/**
 * Display top menu so that it will not exit the viewport.
 *
 * @param $menuItem The top menu menu 'li' element of the current node from TOC / Menu.
 */
function handleMenuPosition($menuItem) {
    // Handle menu position
    const parentDir = rtlEnabled ? 'left' : 'right';
    const index = $('.wh_top_menu ul').index($menuItem.parent('ul'));

    const currentElementOffsetLeft = parseInt($menuItem.offset().left);
    const currentElementWidth = parseInt($menuItem.width());
    const currentElementOffsetRight = currentElementOffsetLeft + currentElementWidth;
    const nextElementWidth = parseInt($menuItem.children('ul').width());
    let offsetLeft,
        offsetRight = currentElementOffsetRight + nextElementWidth;

    if (index == 0) {
        if (parentDir == 'left') {
            $menuItem.attr('data-menuDirection', 'left');
            offsetLeft = currentElementOffsetRight - nextElementWidth;
            if (offsetLeft <= 0) {
                $menuItem.css('position', 'relative');
                $menuItem.children('ul').css('position', 'absolute');
                $menuItem.children('ul').css('right', 'auto');
                $menuItem.children('ul').css('left', '0');
            }
        } else {
            $menuItem.attr('data-menuDirection', 'right');
            offsetRight = currentElementOffsetLeft + nextElementWidth;
            if (offsetRight >= $(window).width()) {
                $menuItem.css('position', 'relative');
                $menuItem.children('ul').css('position', 'absolute');
                $menuItem.children('ul').css('right', '0');
                $menuItem.children('ul').css('left', 'auto');
            }
        }
    } else {
        offsetLeft = currentElementOffsetLeft - nextElementWidth;

        if (parentDir == 'left') {
            if (offsetLeft >= 0) {
                $menuItem.attr('data-menuDirection', 'left');
                $menuItem.children('ul').css('right', '100%');
                $menuItem.children('ul').css('left', 'auto');
            } else {
                $menuItem.attr('data-menuDirection', 'right');
                $menuItem.children('ul').css('right', 'auto');
                $menuItem.children('ul').css('left', '100%');
            }
        } else {
            if (offsetRight <= $(window).width()) {
                $menuItem.attr('data-menuDirection', 'right');
                $menuItem.children('ul').css('right', 'auto');
                $menuItem.children('ul').css('left', '100%');
            } else {
                $menuItem.attr('data-menuDirection', 'left');
                $menuItem.children('ul').css('right', '100%');
                $menuItem.children('ul').css('left', 'auto');
            }
        }
    }
}

export default {
    ATTRS,
    STATE,
    BUTTON_ACTION_ID,
    getPathToRoot,
    handleKeyEvent,
    toggleTocExpand,
    retrieveChildNodes,
    createTopicsList,
    createTopicLi,
    createMenuImageSpan,
    createTopicRefSpan,
    getTopicLinkID,
    hasChildren,
    menuItemHovered,
    handleMenuPosition
};
